interface CheckMarkProps {
  /** Show the tick when true; render nothing when false. */
  readonly on: boolean
  /** Accessible label for the tick (e.g. "Current", "View on Products"). */
  readonly label?: string
}

/**
 * Read-only "is this on?" indicator — a forest tick, or nothing.
 *
 * The single source for catalogue/ledger cells that mirror server or
 * code truth and must not be edited (e.g. the Variant Pricing "Cur"
 * column, the Screen Actions flags). Interactive toggles use <Checkbox>.
 */
export function CheckMark({ on, label }: CheckMarkProps): JSX.Element | null {
  if (!on) return null
  return (
    <span className="text-forest font-bold" aria-label={label}>
      ✓
    </span>
  )
}
